import _ from "lodash";

import { IDashboard } from "model/entities/Dashboard";

export const splitAndSortClientDashboards = (dashboards: IDashboard[]) => {
  //Split default/client dashboards + order the client one by title

  const homeDashboards = _.filter(dashboards, (dashboard: IDashboard) =>
    _.startsWith(dashboard.id, "_home_dashboard_"),
  );
  const otherDashboards = _.sortBy(
    _.filter(
      dashboards,
      (dashboard: IDashboard) =>
        !_.includes(_.map(homeDashboards, "id"), dashboard.id),
    ),
    (dashboard: IDashboard) => dashboard.title,
  );

  return _.concat(homeDashboards, otherDashboards);
};
